import { connect } from 'react-redux';
import AuthenticationView from './Authentication'
import {change} from 'redux-form'
import {isAuthenticatedRequest} from '../../actions/Session'

const mapStateToProps = (state, props) => {
    return {
	
    }
}

const mapDispatchToProps = (dispatch, state) => {
  
    return {
	isAuthenticatedRequest: () => {
	    return dispatch(isAuthenticatedRequest())
	}
    }
}

const AuthenticationMainContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(AuthenticationView);




export default AuthenticationMainContainer;



// WEBPACK FOOTER //
// ./src/utils/AuthneticationProvider/Container.js